// based on https://auth0.com/blog/complete-guide-to-react-user-authentication/
import { Auth0Provider as BaseAuth0Provider } from '@auth0/auth0-react';
import useFeatureGate from '@statsig/react-bindings/src/useFeatureGate';
import { ReactNode } from 'react';

import { providerCustomDomainGate } from '../statsig/gates';
import { getAuth0Config } from './config';
import { useAuthRedirectCallback } from './useAuthRedirectCallback';

export function Auth0Provider({ children }: { children: ReactNode | ReactNode[] }) {
  const { value: isCustomDomainEnabled } = useFeatureGate(providerCustomDomainGate);
  const { audience, scope, clientId, domain, redirectUri, authorizeTimeoutInSeconds, httpTimeoutInSeconds } =
    getAuth0Config(isCustomDomainEnabled);
  const handleAuthRedirect = useAuthRedirectCallback();

  return (
    <BaseAuth0Provider
      authorizationParams={{ redirect_uri: redirectUri, audience, scope }}
      httpTimeoutInSeconds={httpTimeoutInSeconds}
      authorizeTimeoutInSeconds={authorizeTimeoutInSeconds}
      cacheLocation='localstorage'
      onRedirectCallback={(appState) => {
        handleAuthRedirect({ appState, currentPath: location.pathname });
      }}
      useRefreshTokens
      useRefreshTokensFallback
      clientId={clientId}
      domain={domain}
    >
      {children}
    </BaseAuth0Provider>
  );
}
